import React from "react";

import { CatalogueRightSideWrapper } from "../catalogue.styles";
import AddedItems from "./AddedItems";
import TotalSummaryCharge from "./TotalSummaryCharge";
import OrderHeaderSection from "./OrderHeaderSection";

const OrderDetails = ({ totalPrice }) => {
    return (
        <CatalogueRightSideWrapper>
            <OrderHeaderSection />
            <AddedItems />
            <TotalSummaryCharge {...{ totalPrice }} />
        </CatalogueRightSideWrapper>
    );
};

export default OrderDetails;
